import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconBlockedStyle0 = gravityIconIndividualCss;

const GravityIconBlocked = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'd34b839ae310024c49dd09757c614e605d550477', color: this.color, size: this.size }, h("svg", { key: '4aa820c33c87dc6870cbade0c7ddc17a01e43fbf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'a25d6065e573e3cd5192b77e684b06d704ca37c8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 20a9 9 0 0 0 9-9 9.01 9.01 0 0 0-9-9 9 9 0 0 0 0 18ZM6.253 5.193A7.469 7.469 0 0 1 11 3.5a7.51 7.51 0 0 1 7.5 7.5 7.47 7.47 0 0 1-1.693 4.747L6.253 5.193Zm-1.06 1.06a7.5 7.5 0 0 0 10.554 10.554L5.192 6.253Z", fill: "currentColor" }))));
    }
};
GravityIconBlocked.style = GravityIconBlockedStyle0;

export { GravityIconBlocked as gravity_icon_blocked };

//# sourceMappingURL=gravity-icon-blocked.entry.js.map